import React, { useEffect, useState } from "react";
import { useSwipeable } from "react-swipeable";
import "./CoalitionCarousel.scss";

export const CoalitionCarousel = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  const setIdx = (newIndex) => {
    if (newIndex < 0) {
      newIndex = React.Children.count(children) - 1;
    } else if (newIndex >= React.Children.count(children)) {
      newIndex = 0;
    }
    setActiveIndex(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!paused) setIdx(activeIndex + 1);
    }, 3000);

    return () => {
      if (interval) clearInterval(interval);
    };
  });

  const handlers = useSwipeable({
    onSwipedLeft: () => setIdx(activeIndex + 1),
    onSwipedRight: () => setIdx(activeIndex - 1),
  });

  return (
    <div className="carousel">
      <div
        {...handlers}
        className="handler"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div
          className="inner"
          style={{ transform: `translateX(-${activeIndex * 100}%)` }}
        >
          {React.Children.map(children, (child) =>
            React.cloneElement(child, { width: "100%" })
          )}
        </div>
        {children.length > 1 ? (
          <div className="indicators">
            {React.Children.map(children, (_, index) => {
              return (
                <button
                  className={`${index === activeIndex ? "active" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setIdx(index)}
                />
              );
            })}
          </div>
        ) : null}
      </div>
    </div>
  );
};
